export default __webpack_public_path__ + "static/media/ac_bw.7dbd16de.bmp";